// Hook dodania kalkulacji do pozycji oferty –
// POST /sales-crm/clients/:cid/offers/:oid/positions/:pid/calculations

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

export interface IPostSalesCrmOfferCalculationPayload {
  name: string;
  quantity: number;
  description?: string;
}

export interface ISalesCrmOfferCalculation {
  id: number;
  name: string;
  offerVersionPositionId?: number;
}

export type IPostSalesCrmOfferCalculationResponse = ICommandResponseSuccess &
  Partial<ISalesCrmOfferCalculation>;

const postSalesCrmOfferCalculation = (
  clientId: number,
  offerId: string,
  positionId: number,
  payload: IPostSalesCrmOfferCalculationPayload
): Promise<IPostSalesCrmOfferCalculationResponse> =>
  axios.post(
    `/sales-crm/clients/${clientId}/offers/${offerId}/positions/${positionId}/calculations`,
    payload
  );

export const usePostSalesCrmOfferCalculation = (
  clientId: number,
  offerId: string,
  positionId: number,
  options?: UseMutationOptions<
    IPostSalesCrmOfferCalculationResponse,
    IError,
    IPostSalesCrmOfferCalculationPayload
  >
) =>
  useMutation(
    (payload: IPostSalesCrmOfferCalculationPayload) =>
      postSalesCrmOfferCalculation(clientId, offerId, positionId, payload),
    options
  );
